import { ExampleLabel } from "./ExampleLabel";

export function SecondBrain() {
  return (
    <section className="sec brain" id="brainSec">
      <div className="eyebrow" style={{ justifyContent: "center", display: "inline-flex" }}>
        <span className="bar" /> The Second Brain · What makes Voy Voy <span className="bar" />
      </div>
      <h2>
        Every trip makes Voy <span className="italic">smarter.</span>
      </h2>
      <p className="lede">
        Voy is built around a persistent memory layer. Every search, click, booking, and stated preference becomes
        structured, permanent, user editable context that every Voy agent reads from. The system knows you better in
        month six than in month one. In year two, more than a stranger ever could.
      </p>

      <ExampleLabel />
      <div className="brain-grid">
        <div className="brain-col">
          <div className="brain-h">
            <span className="num">01</span> What you've told us
          </div>
          <ul className="brain-list">
            <li><span className="k">Home airports</span><span className="v">SFO, BUE</span></li>
            <li><span className="k">Passport</span><span className="v">ARG, valid through 2031</span></li>
            <li><span className="k">Loyalty</span><span className="v">United 1K, Marriott Titanium, IHG Diamond</span></li>
            <li><span className="k">Travelers</span><span className="v">Marisol (partner), Lucia (daughter, 7)</span></li>
            <li><span className="k">Dietary</span><span className="v">vegetarian, no shellfish</span></li>
          </ul>
          <div className="brain-source">From profile, loyalty, companions</div>
        </div>

        <div className="brain-col mid">
          <div className="brain-h">
            <span className="num">02</span> What we've learned
          </div>
          <ul className="brain-list">
            <li><span className="k">Return day</span><span className="v">Books Sunday returns 78% of the time</span></li>
            <li><span className="k">Trip length</span><span className="v">6 to 8 nights typical</span></li>
            <li><span className="k">Average budget</span><span className="v">$2,200 per trip</span></li>
            <li><span className="k">Lead time</span><span className="v">Books 14 to 21 days ahead</span></li>
            <li><span className="k">Hotel pattern</span><span className="v">Prefers boutique over chains</span></li>
          </ul>
          <div className="brain-source">From AI insights on your history</div>
        </div>

        <div className="brain-col">
          <div className="brain-h">
            <span className="num">03</span> What's on your mind
          </div>
          <ul className="brain-list">
            <li><span className="k">Portugal</span><span className="v">4 searches in last 60 days</span></li>
            <li><span className="k">Anniversary</span><span className="v">June trip, told us May 2</span></li>
            <li><span className="k">Watching</span><span className="v">SFO to LIS fares</span></li>
            <li><span className="k">Saved itinerary</span><span className="v"><em>Lisbon, first week of June</em></span></li>
            <li><span className="k">Last booked</span><span className="v">CDG, March 12</span></li>
          </ul>
          <div className="brain-source">From recent search activity</div>
        </div>
      </div>

      <div className="brain-actions">
        <button type="button" className="brain-action">Edit your memory</button>
        <button type="button" className="brain-action">Export your data</button>
        <button type="button" className="brain-action danger">Delete forever</button>
      </div>

    </section>
  );
}
